import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { get } from 'lodash';

const colorMapping = {
  green: 'var(--input-group-valid-info-color)',
  red: 'var(--input-group-invalid-info-color)',
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xvi-bell-renderer',
  templateUrl: './bell-renderer.component.html',
  styleUrls: ['./bell-renderer.component.scss'],
})
export class XVIBellRendererComponent implements AgRendererComponent {
  @Input() public value: string | null = null;

  public agInit(params: ICellRendererParams): void {
    this.value = get(params, 'value', null);
    this.value = get(colorMapping, this.value, this.value);
  }

  public refresh(): boolean {
    return true;
  }
}
